export const environment = {
    production: true,
    api_url_base_dataform_component: '###{api_url_base_dataform_component}###',
    api_url_base_validate_access: '###{api_url_base_validate_access}###',
    api_url_br: '###{api_url_br}###',

    // Secure-Comm Gateway Configuration
    secureComm: {
        apiBaseUrl: '###{secure_comm_api_base_url}###'
    }
};
